import React from "react";

type Props = {
  name: string;
  avatarUrl: string;
  className?: string;
};

const SIZE = 20;

const Avatar = ({ name, avatarUrl, className }: Props) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = "//www.gravatar.com/avatar/?d=mp&s=" + SIZE;
    e.currentTarget.onerror = undefined;
  };

  return (
    <span className={className}>
      <img
        src={avatarUrl}
        onError={handleError}
        style={{ width: SIZE, height: SIZE }}
        className="mr-[5px] rounded-full"
        alt={`Avatar for ${name}`}
      />
      <span>{name}</span>
    </span>
  );
};

export default Avatar;
